var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let ProjectInfo = class ProjectInfo extends Vue {
};
__decorate([
    Prop()
], ProjectInfo.prototype, "label", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "value", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "width", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "padding", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "valueSize", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "textGray", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "alignTop", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "borderLight", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "hideBorder", void 0);
__decorate([
    Prop()
], ProjectInfo.prototype, "paddingSize", void 0);
ProjectInfo = __decorate([
    Component({
        components: {}
    })
], ProjectInfo);
export default ProjectInfo;
